export const c_tree_view__node_toggle_icon_Transition = {
  "name": "--pf-c-tree-view__node-toggle-icon--Transition",
  "value": "transform 250ms cubic-bezier(.645, .045, .355, 1)",
  "var": "var(--pf-c-tree-view__node-toggle-icon--Transition)"
};
export default c_tree_view__node_toggle_icon_Transition;